/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookie_Consent_SaveInputs */

const en_cookie_consent_save = /** @type {(inputs: Cookie_Consent_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Preferences`)
};

const de_cookie_consent_save = /** @type {(inputs: Cookie_Consent_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen speichern`)
};

const fr_cookie_consent_save = /** @type {(inputs: Cookie_Consent_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer les preferences`)
};

const es_cookie_consent_save = /** @type {(inputs: Cookie_Consent_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar preferencias`)
};

const it_cookie_consent_save = /** @type {(inputs: Cookie_Consent_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva preferenze`)
};

const nl_cookie_consent_save = /** @type {(inputs: Cookie_Consent_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voorkeuren opslaan`)
};

const pl_cookie_consent_save = /** @type {(inputs: Cookie_Consent_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapisz preferencje`)
};

const fi_cookie_consent_save = /** @type {(inputs: Cookie_Consent_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tallenna asetukset`)
};

const da_cookie_consent_save = /** @type {(inputs: Cookie_Consent_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gem praeferencer`)
};

const sv_cookie_consent_save = /** @type {(inputs: Cookie_Consent_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spara installningar`)
};

/**
* | output |
* | --- |
* | "Save Preferences" |
*
* @param {Cookie_Consent_SaveInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cookie_consent_save = /** @type {((inputs?: Cookie_Consent_SaveInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_Consent_SaveInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cookie_consent_save(inputs)
	if (locale === "fr") return fr_cookie_consent_save(inputs)
	if (locale === "es") return es_cookie_consent_save(inputs)
	if (locale === "it") return it_cookie_consent_save(inputs)
	if (locale === "nl") return nl_cookie_consent_save(inputs)
	if (locale === "pl") return pl_cookie_consent_save(inputs)
	if (locale === "fi") return fi_cookie_consent_save(inputs)
	if (locale === "da") return da_cookie_consent_save(inputs)
	if (locale === "sv") return sv_cookie_consent_save(inputs)
	return en_cookie_consent_save(inputs)
});